export const FETCH_CUSTOMER_ORDER = 'FETCH_CUSTOMER_ORDER';
export const FETCH_CUSTOMER_ORDER_SUCCESS = 'FETCH_CUSTOMER_ORDER_SUCCESS';
export const FETCH_CUSTOMER_ORDER_FAILURE = 'FETCH_CUSTOMER_ORDER_FAILURE';
